export default __webpack_public_path__ + "7e455ef27ade88035fd589ce7392ad48.svg";